// extracted by mini-css-extract-plugin
module.exports = {"remedy-pxp":"Remedy_remedy-pxp__xIUDC"};